'use strict';

var focusHelper = require('../components/focus');
const baseHelper = require('./base-helper');
const productGallery = require('./productGallery');
const productAccordion = require('./productAccordion');
const productCtaBox = require('./productCtaBox');
const initSwiperSlider = require('../components/swiperSlider').initSwiperSlider;
const { handleNotifyMe } = require('../notifyme/backInStock');
const { showToastMessage } = require('../../js/components/toast');
const initVideoElements = require('../components/videoElement');

/**
 * updates the product view when a product attribute is selected or deselected or when
 *         changing quantity
 * @param {string} selectedValueUrl - the Url for the selected variation value
 * @param {jQuery} $productContainer - DOM element for current product
 */
function attributeSelect(selectedValueUrl, $productContainer) {
    if (selectedValueUrl) {
        $('body').trigger(
            'product:beforeAttributeSelect',
            { url: selectedValueUrl, container: $productContainer }
        );

        $.ajax({
            url: selectedValueUrl,
            method: 'GET',
            success: function (data) {
                let $result = $(data);
                let productURL = $result.find('.js-product-detail').data('url');
                if ($productContainer.hasClass('js-product-detail-wrapper')) {
                    // avoid nesting .js-product-detail-wrapper inside itself
                    $productContainer.replaceWith($result);
                } else {
                    $productContainer.empty().html(data);
                }
                productGallery();
                productAccordion();
                productCtaBox();
                handleNotifyMe();
                initVideoElements();
                const awardSlider = document.querySelector('#product-detail-content-accordion-body-id-awards .js-global-swiper-slider');
                if (awardSlider) {
                    initSwiperSlider(awardSlider);
                }
                const fpsPerformanceSlider = document.querySelector('.js-fps-performance-swiper-container');
                if (fpsPerformanceSlider) {
                    initSwiperSlider(fpsPerformanceSlider);
                }
                var eolContainer = document.querySelector('.js-product-eol-recommendations');
                if (eolContainer) {
                    var eolSlider = eolContainer.querySelector('.js-eol-swiper-slider');
                    if (eolSlider) {
                        initSwiperSlider(eolSlider);
                    } else {
                        var observer = new MutationObserver(function (_, obs) {
                            eolSlider = eolContainer.querySelector('.js-eol-swiper-slider');
                            if (eolSlider) {
                                initSwiperSlider(eolSlider);
                                obs.disconnect();
                            }
                        });
                        observer.observe(eolContainer, { childList: true, subtree: true });
                    }
                }
                window.history.pushState('', '', productURL);
                $.spinner().stop();

                document.dispatchEvent(new CustomEvent('pdp:productVariationAjaxDone', {}));
            },
            error: function () {
                $.spinner().stop();
            }
        });
    }
}

function triggerVariantProductSelector(context, e) {
    var $productContainer = $(context).closest('.js-product-detail-wrapper');
    if (!$productContainer.length) {
        $productContainer = $(context).closest('.modal-content').find('.product-quickview');
    }
    const selectedAttributeId = 'selectedAttributeId=' + $(e.currentTarget).data('variant-attrid');
    let selectedProductUrl = $(e.currentTarget).find('option:selected').data('url')
        ? $(e.currentTarget).find('option:selected').data('url')
        : $(e.currentTarget).data('url');
    const separator = selectedProductUrl.indexOf('?') === -1 ? '?' : '&';
    selectedProductUrl = selectedProductUrl + separator + selectedAttributeId;

    if ($('.bundle-items', $productContainer).length === 0 && selectedProductUrl) {
        attributeSelect(
            selectedProductUrl,
            $productContainer
        );
    }
}

module.exports = {
    attributeSelect: attributeSelect,
    methods: {
        editBonusProducts: function (data) {
            baseHelper.chooseBonusProducts(data);
        }
    },

    focusChooseBonusProductModal: function () {
        $('body').on('shown.bs.modal', '#choose-bonus-product-modal', function () {
            $('#choose-bonus-product-modal').siblings().attr('aria-hidden', 'true');
            $('#choose-bonus-product-modal .close').focus();
        });
    },

    onClosingChooseBonusProductModal: function () {
        $('body').on('hidden.bs.modal', '#choose-bonus-product-modal', function () {
            $('#choose-bonus-product-modal').siblings().attr('aria-hidden', 'false');
        });
    },

    trapChooseBonusProductModalFocus: function () {
        $('body').on('keydown', '#choose-bonus-product-modal', function (e) {
            var focusParams = {
                event: e,
                containerSelector: '#choose-bonus-product-modal',
                firstElementSelector: '.close',
                lastElementSelector: '.add-bonus-products'
            };
            focusHelper.setTabNextFocus(focusParams);
        });
    },

    colorAttribute: function () {
        $(document).on('click', '[data-attr="color"] button', function (e) {
            e.preventDefault();

            if ($(this).attr('disabled')) {
                return;
            }
            var $productContainer = $(this).closest('.set-item');
            if (!$productContainer.length) {
                $productContainer = $(this).closest('.js-product-detail-wrapper');
            }

            attributeSelect($(this).attr('data-url'), $productContainer);
        });
    },

    selectAttribute: function () {
        $(document).on('change', 'select[class*="select-"], .options-select, .js-options-radio', function (e) {
            e.preventDefault();

            var $productContainer = $(this).closest('.set-item');
            if (!$productContainer.length) {
                $productContainer = $(this).closest('.js-product-detail-wrapper');
            }
            attributeSelect($(this).attr('data-url'), $productContainer);
        });
    },

    availability: function () {
        $(document).on('change', '.quantity-select, select.js-variant-selector', function (e) {
            e.preventDefault();
            triggerVariantProductSelector(this, e);
        });

        $(document).on('click', 'button.js-variant-selector', function (e) {
            e.preventDefault();
            triggerVariantProductSelector(this, e);
        });
    },
    selectBonusProduct: function () {
        $(document).on('click', '.select-bonus-product', function () {
            var $choiceOfBonusProduct = $(this).parents('.choice-of-bonus-product');
            var pid = $(this).data('pid');
            var maxPids = $('.choose-bonus-product-dialog').data('total-qty');
            var submittedQty = parseInt($choiceOfBonusProduct.find('.bonus-quantity-select').val(), 10);
            var totalQty = 0;
            $.each($('#choose-bonus-product-modal .selected-bonus-products .selected-pid'), function () {
                totalQty += $(this).data('qty');
            });
            totalQty += submittedQty;
            var optionID = $choiceOfBonusProduct.find('.product-option').data('option-id');
            var valueId = $choiceOfBonusProduct.find('.options-select option:selected').data('valueId');
            if (totalQty <= maxPids) {
                var selectedBonusProductHtml = ''
                + '<div class="selected-pid row" '
                + 'data-pid="' + pid + '"'
                + 'data-qty="' + submittedQty + '"'
                + 'data-optionID="' + (optionID || '') + '"'
                + 'data-option-selected-value="' + (valueId || '') + '"'
                + '>'
                + '<div class="col-sm-11 col-9 bonus-product-name" >'
                + $choiceOfBonusProduct.find('.product-name').html()
                + '</div>'
                + '<div class="col-1"><span aria-hidden="true">&times;</span></div>'
                + '</div>';
                $('#choose-bonus-product-modal .selected-bonus-products').append(selectedBonusProductHtml);
                $('.pre-cart-products').html(totalQty);
                $('.selected-bonus-products .bonus-summary').removeClass('alert-danger');
            } else {
                $('.selected-bonus-products .bonus-summary').addClass('alert-danger');
            }
        });
    },
    removeBonusProduct: function () {
        $(document).on('click', '.selected-pid', function () {
            $(this).remove();
            var $selected = $('#choose-bonus-product-modal .selected-bonus-products .selected-pid');
            var count = 0;
            if ($selected.length) {
                $selected.each(function () {
                    count += parseInt($(this).data('qty'), 10);
                });
            }

            $('.pre-cart-products').html(count);
            $('.selected-bonus-products .bonus-summary').removeClass('alert-danger');
        });
    },
    enableBonusProductSelection: function () {
        $('body').on('bonusproduct:updateSelectButton', function (e, response) {
            $('button.select-bonus-product', response.$productContainer).attr(
                'disabled',
                (!response.product.readyToOrder || !response.product.available)
            );
            var pid = response.product.id;
            $('button.select-bonus-product', response.$productContainer).data('pid', pid);
        });
    },
    showMoreBonusProducts: function () {
        $(document).on('click', '.show-more-bonus-products', function () {
            var url = $(this).data('url');
            $('.modal-content').spinner().start();
            $.ajax({
                url: url,
                method: 'GET',
                success: function (html) {
                    var parsedHtml = baseHelper.parseHtml(html);
                    $('.modal-body').append(parsedHtml.body);
                    $('.show-more-bonus-products:first').remove();
                    $('.modal-content').spinner().stop();
                },
                error: function () {
                    $('.modal-content').spinner().stop();
                }
            });
        });
    },
    addBonusProductsToCart: function () {
        $(document).on('click', '.add-bonus-products', function () {
            var $readyToOrderBonusProducts = $('.choose-bonus-product-dialog .selected-pid');
            var queryString = '?pids=';
            var url = $('.choose-bonus-product-dialog').data('addtocarturl');
            var pidsObject = {
                bonusProducts: []
            };

            $.each($readyToOrderBonusProducts, function () {
                var qtyOption = parseInt($(this)
                    .data('qty'), 10);

                var option = null;
                if (qtyOption > 0) {
                    if ($(this).data('optionid') && $(this).data('option-selected-value')) {
                        option = {};
                        option.optionId = $(this).data('optionid');
                        option.productId = $(this).data('pid');
                        option.selectedValueId = $(this).data('option-selected-value');
                    }
                    pidsObject.bonusProducts.push({
                        pid: $(this).data('pid'),
                        qty: qtyOption,
                        options: [option]
                    });
                    pidsObject.totalQty = parseInt($('.pre-cart-products').html(), 10);
                }
            });
            queryString += JSON.stringify(pidsObject);
            queryString = queryString + '&uuid=' + $('.choose-bonus-product-dialog').data('uuid');
            queryString = queryString + '&pliuuid=' + $('.choose-bonus-product-dialog').data('pliuuid');
            $.spinner().start();
            $.ajax({
                url: url + queryString,
                method: 'POST',
                success: function (data) {
                    $.spinner().stop();
                    if (data.error) {
                        $('#choose-bonus-product-modal').modal('hide');

                        showToastMessage({
                            message: data.errorMessage,
                            alertType: 'alert-danger',
                            alertQa: 'pdp-error-alert',
                            disableAutoClosing: true
                        });
                    } else {
                        $('.configure-bonus-product-attributes').html(data);
                        $('.bonus-products-step2').removeClass('hidden-xl-down');
                        $('#choose-bonus-product-modal').modal('hide');
                        $('.minicart-quantity').html(data.totalQty);

                        showToastMessage({
                            message: data.msgSuccess,
                            alertType: 'alert-success'
                        });

                        setTimeout(function () {
                            if ($('.cart-page').length) {
                                window.location.reload();
                            }
                        }, 3000);
                    }
                },
                error: function () {
                    $.spinner().stop();
                }
            });
        });
    },

    getPidValue: baseHelper.getPidValue,
    getQuantitySelected: baseHelper.getQuantitySelected,
    miniCartReportingUrl: baseHelper.miniCartReportingUrl
};
